// extracted by mini-css-extract-plugin
module.exports = {"button":"CartProductDelete_button__3ttqT","icon":"CartProductDelete_icon__15p7E"};